module.exports = __webpack_public_path__ + "img/images_homebanner_5-2.84e45aed.png";